export default __webpack_public_path__ + "static/media/lana.6f90d74c.jpeg";